// extracted by mini-css-extract-plugin
export default {"sellerShowProduct":"styles_sellerShowProduct__54REr","empty":"styles_empty__zqdze"};